import styled from 'styled-components';
import Colors from '../../utils/Colors';

export const Container = styled.div<{ width?: string; height?: string }>`
  width: ${props => props.width || '100vw'};
  height: ${props => props.height || '100vh'};
  background-color: ${Colors.white};
  color: ${Colors.black};
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  flex-direction: column;
  gap: 10px;
  padding: 0 20px;
`;

export const Error = styled.div`
  font-size: 18px;
  text-align: center;
  color: ${Colors.error};
  font-weight: 600;
`;

export const RefreshButton = styled.button`
  background-color: ${Colors.orange};
  color: ${Colors.white};
  border: none;
  padding: 12px 24px;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  margin-top: 16px;

  &:hover {
    opacity: 0.9;
  }
`;
